/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Export_Daily_ExcelInputs */

const vi_order_export_daily_excel = /** @type {(inputs: Order_Export_Daily_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel ngày`)
};

/**

* @param {Order_Export_Daily_ExcelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_export_daily_excel = /** @type {((inputs?: Order_Export_Daily_ExcelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Export_Daily_ExcelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_export_daily_excel(inputs)
});